<template>
  <div class="application-main">
    <ctint-report-main v-if="isExists('ctintreport')" v-show="routerPage == 'ctintreport'" />
    <ctint-router-page-content :routerPage="routerPage" @openSelectedTask="openSelectedTask" :routerItems="routerItems" />
  </div>
</template>

<script>
import TabManager from "@ctint/client-core-tabmanager-js/src/tabmanager/TabManager";

export default {
  components: {},
  data() {
    return {};
  },
  props: {
    namespace: { type: String, default: "ctint-main-tab/single" },
    routerItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  created() {
    console.log("CtintRouterPageContent created");
  },
  watch: {},
  mounted() {},
  computed: {
    routerPage() {
      return this.tabmanager().getRouterPage();
    },
  },
  beforeDestroy() {},
  destoyed() {},
  methods: {
    isExists(key) {
      let list = this.routerItems.filter((i) => i.slug == key);
      if (list && list[0]) {
        return true;
      }
      return false;
    },
    tabmanager() {
      this.tabmanagerInst = TabManager.getOrNewInstance(this.tabmanagerInst, this.$store, this.namespace);
      return this.tabmanagerInst;
    },
    openSelectedTask(selectedContent, action) {
      this.$emit("openSelectedTask", selectedContent, action);
    },
  },
};
</script>
<style lang="stylus">
.multi-tab {
  button:focus {
    outline: none;
  }

  .vs-tabs-primary .con-ul-tabs .activeChild button, .vs-tabs-primary .con-ul-tabs button:not(:disabled):hover {
    color: var(--ctint-color-secondary) !important;
  }

  .vs-tabs--li button {
    color: var(--ctint-color-unselected);
  }

  .activeChild button.vs-tabs--btn {
    padding-top: 10px;
  }

  .vs-tabs-position-top .vs-tabs--ul {
    flex-wrap: unset;
    box-shadow: none;
  }

  .tab-slide-left, .tab-slide-right {
    position: absolute;
    margin-top: 10px;
    z-index: 1;
    width: 20px;
    height: 20px;
    font-size: 10px;
    border-radius: 50%;
    background: var(--ctint-color-secondary);
    color: white;
    border: none;
  }

  .tab-slide-left {
    margin-left: 10px;
    left: 0;
  }

  .tab-slide-right {
    margin-right: 10px;
    right: 0;
  }
}
</style>